export default __webpack_public_path__ + "static/icon-25-2-0bcc447b6947f9b37bc11f4ae21d0c42.png";